import { useDispatch, useSelector } from "react-redux";
import { useBullseyeLocations as useLocations } from '@pcf-engineering/pcs-ui-kit/hooks';

import { updateStoreCategories } from "../../redux/reducers/sharedReducer";
import { storeCategoriesSelector } from "../../redux/selectors/sharedSelectors";

const useBullseyeLocations = options => {
  const dispatch = useDispatch();
  const stateCategories = useSelector(storeCategoriesSelector);
  const stateDispatcher = (categories) => dispatch(updateStoreCategories(categories));
  const result = useLocations({ options, stateDispatcher, stateCategories });

  return result;
};

export default useBullseyeLocations;
